var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOrangeStreaks(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 411,
    height: 74,
    viewBox: "0 0 411 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M706.57 0V32.4425L705.189 33.065C485.97 33.1561 266.843 32.3363 47.6087 32.6703L0 1.39668L0.242907 0.394707L706.57 0Z",
    fill: "#EA5B0C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M706.57 41.7943V73.2501H108.213C93.0162 62.6687 76.8025 53.5143 61.5149 43.0847C61.1505 42.8418 60.7861 43.1455 60.9987 42.2042L706.586 41.8095L706.57 41.7943Z",
    fill: "#EA5B0C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrangeStreaks);
export default __webpack_public_path__ + "static/media/orange-streaks.82471a2b7a6d4634aec0dcd037fa5eec.svg";
export { ForwardRef as ReactComponent };